import React from 'react'
// @ts-ignore
import { FoamTree } from '@netbasequid/chart'

interface FoamTreeChartProps {
  height: string
  dataObject: {
    groups: Array<object>
  }
  className?: string
}

const FoamTreeChart = ({ height, dataObject, className }: FoamTreeChartProps) => (
  <FoamTree height={height} dataObject={dataObject} className={className} />
)

export default FoamTreeChart
